<template>
  <Auth :auth="auth">
    <template v-slot:default>
      <i v-bind="$attrs" v-on="$listeners">
        <slot></slot>
      </i>
    </template>
  </Auth>
</template>

<script>
  import Auth from './Auth'
  export default {
    name: 'l-auth-icon',
    components: {
      Auth
    },
    props: {
      auth: {
        type: String,
        required: true
      }
    }
  }
</script>